import React, { useEffect, useRef, useState } from 'react';
import { eventsAPI, usersAPI } from '../../api/client';
import { errorMessage } from '../../lib/evaluationIntegrity';
import { rows, STAGES } from '../../lib/traceability';
import TeamSelector from './TeamSelector';
import { Field } from './Fields';

export default function EventPreparation({ event, canEdit, onChanged }) {
  const [form, applyForm] = useState(event);
  const dirty = useRef(false);
  const eventId = useRef(event.id);
  const setForm = (next) => {
    dirty.current = true;
    applyForm(next);
  };
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  // #Fase3-G3 — Recargar un hallazgo no debe borrar cambios de preparación sin guardar.
  useEffect(() => {
    if (eventId.current !== event.id || !dirty.current) {
      eventId.current = event.id;
      dirty.current = false;
      applyForm(event);
    }
  }, [event]);
  useEffect(() => {
    if (!canEdit) return;
    usersAPI.list({ role: 'levantador', limit: 500 }).then(({ data }) => setUsers(rows(data))).catch(() => {
      setError('No se pudo cargar el equipo. Recarga para reintentar.');
    });
  }, [canEdit]);
  // #Fase3-G3 — Tampoco reenviar al principal si una respuesta antigua lo incluyó en el equipo.
  const team = (form.assigned_user_ids || []).filter((id) => id !== form.assigned_levantador_id);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await eventsAPI.update(event.id, {
        organizer_name: form.organizer_name || '', organizer_company: form.organizer_company || '',
        requirements: (form.requirements || []).filter((value) => value.trim()),
        risks: form.risks || [], stage_override: form.stage_override || null, assigned_user_ids: team,
      });
      dirty.current = false;
      await onChanged();
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };
  return <form className="soem-card p-4 space-y-3" onSubmit={save}>
    <h2 className="font-bold">Preparación del evento</h2>
    {error && <p role="alert">{error}</p>}
    <fieldset disabled={!canEdit || busy} className="space-y-3">
      <Field label="Organizador" value={form.organizer_name}
        onChange={(organizer_name) => setForm({ ...form, organizer_name })} />
      <Field label="Empresa / agencia organizadora" value={form.organizer_company}
        onChange={(organizer_company) => setForm({ ...form, organizer_company })} />
      <Field label="Requerimientos (uno por línea)" multiline value={(form.requirements || []).join('\n')}
        onChange={(value) => setForm({ ...form, requirements: value.split('\n') })} />
      <h3>Riesgos identificados</h3>
      {(form.risks || []).map((risk, index) => <div key={index} className="grid md:grid-cols-3 gap-2">
        <Field label="Riesgo" required value={risk.description} onChange={(description) => setForm({
          ...form, risks: form.risks.map((row, i) => i === index ? { ...row, description } : row),
        })} />
        <Field label="Nivel" value={risk.level} options={{ bajo: 'Bajo', medio: 'Medio', alto: 'Alto' }}
          onChange={(level) => setForm({
            ...form, risks: form.risks.map((row, i) => i === index ? { ...row, level } : row),
          })} />
        {canEdit && <button type="button" onClick={() => setForm({
          ...form, risks: form.risks.filter((_, i) => i !== index),
        })}>Quitar riesgo</button>}
      </div>)}
      {canEdit && <button type="button" onClick={() => setForm({
        ...form, risks: [...(form.risks || []), { description: '', level: 'medio' }],
      })}>Agregar riesgo</button>}
      <Field label="Ajuste manual de etapa" value={form.stage_override}
        options={{ '': 'Automática según estatus y fechas', ...STAGES }}
        onChange={(stage_override) => setForm({ ...form, stage_override })} />
      {canEdit && <TeamSelector users={users} value={team} principalId={form.assigned_levantador_id}
        onChange={(assigned_user_ids) => setForm({ ...form, assigned_user_ids })} />}
      {canEdit && <button className="soem-btn-primary p-2">Guardar preparación y equipo</button>}
    </fieldset>
  </form>;
}
